import { inject } from '@angular/core';
import { signalStore, type, withProps } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import {
  withCallStatus,
  withEntitiesLoadingCall,
  withLogger,
} from '@ngrx-traits/signals';
import {
  SalvageExchangeProvider,
  CustomisationSalvageExchangeService,
} from '..';
import { map } from 'rxjs';

const salvageExchangeProviderConfig = entityConfig({
  entity: type<SalvageExchangeProvider>(),
  collection: 'salvageExchangeProvider',
  selectId: (entity: SalvageExchangeProvider) => entity.id,
});

export const CustomisationSalvageExchangeStore = signalStore(
  withEntities(salvageExchangeProviderConfig),
  withCallStatus(salvageExchangeProviderConfig, {
    initialValue: 'loading',
  }),
  withLogger({
    name: 'CustomisationSalvageExchangeStore',
    showDiff: true,
  }),
  withProps(() => ({
    _customisationSalvageExchangeService: inject(
      CustomisationSalvageExchangeService
    ),
  })),
  withEntitiesLoadingCall(({ _customisationSalvageExchangeService }) => ({
    collection: salvageExchangeProviderConfig.collection,
    mapError: (error) => error,
    fetchEntities: () =>
      _customisationSalvageExchangeService
        .get()
        .pipe(map((response) => response.items)),
  }))
);
